import { MDBCard, MDBCardBody, MDBCardHeader, MDBCardTitle, MDBInput } from "mdb-react-ui-kit";
import { useState } from "react";
import { SketchPicker } from "react-color";
import Select from "react-select"
import ColorPicker from "./ColorPicker";

const Ribbon = (props) => {
    const {ribbon, setRibbon} = props;
    const ribbonAlignOptions = [
        { value: 'left', label: 'Left'},
        { value: 'center', label: 'Center'},
        { value: 'right', label: 'Right'},
    ]

    const handleRibbonInputChange = (e) => {
        setRibbon({
            ...ribbon,
            [e.target.name]: e.target.value
        })
    }
    const handleRibbonAlignChange = (opt) => {
        setRibbon({
            ...ribbon,
            align: opt.value,
        });
    }

    return (
        <MDBCard className="cms-ribbon mt-4">
            <MDBCardHeader>
                <MDBCardTitle>Ribbon</MDBCardTitle>
            </MDBCardHeader>
            <MDBCardBody>
                <div className="d-flex align-items-center">
                    <label className="me-2">Text:</label>
                    <MDBInput name="content" value={ribbon?.content ?? ''} onChange={handleRibbonInputChange} />
                </div>

                <div className="d-flex mt-3">
                    <ColorPicker 
                        label="Background Color:"
                        color={ribbon?.bg_color} 
                        setColor={(color) => {
                            setRibbon({
                                ...ribbon,
                                bg_color: color
                            })
                        }}
                    />

                    <ColorPicker
                        className="ms-4"
                        label="Text Color:"
                        color={ribbon?.txt_color}
                        setColor={(color) => {
                            setRibbon({
                                ...ribbon,
                                txt_color: color
                            })
                        }}
                    />

                    <div className="ms-4 d-flex align-items-center">
                        <label className="me-2">Align:</label>
                        <Select options={ribbonAlignOptions}
                            value={ribbonAlignOptions.find(opt=>opt.value == ribbon?.align)}
                            onChange={opt => handleRibbonAlignChange(opt)}
                        />
                    </div>
                </div>
            </MDBCardBody>
        </MDBCard>
        )
}

export default Ribbon;